import { defineMessages, useIntl } from 'react-intl';
import { useEffect, useState } from 'react';

import { SelectInput } from '@arpav/components';

const messages = defineMessages({
  emaillabel: {
    id: 'Indirizzo email a cui inviare i dati *',
    defaultMessage: 'Indirizzo email a cui inviare i dati *',
  },
  invalidEmail: {
    id: '* Indirizzo email valido',
    defaulMessage: '* Indirizzo email valido',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
  selectOption: {
    id: 'Selezionare una voce',
    defaultMessage: 'Selezionare una voce',
  },
});

const ListField = ({ formData, setFormData, filter, error, setError }) => {
  const intl = useIntl();
  const [formListOptions, setFormListOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    const fullArray = filter?.provinceValues
      ? filter.provinceValues.split('\n').filter(line => line.trim() !== '')
      : [];
    const jsonArray = fullArray.map(line => {
      const [value, label] = line.split('|').map(part => part.trim());
      return { value, label, name: label };
    });

    const optionsWithDefault = [
      {
        value: '',
        label: intl.formatMessage(messages.selectOption),
        name: intl.formatMessage(messages.selectOption),
      },
      ...jsonArray,
    ];

    setFormListOptions(optionsWithDefault);
  }, [filter]);

  /**
   * List filter validator
   */
  const listValidator = selectedOption => {
    if (selectedOption?.name) {
      setFormData(formData => ({
        ...formData,
        [filter?.propertyField]: selectedOption?.value,
      }));
      setSelectedValue(selectedOption);

      if (filter?.mandatory && !selectedOption?.value) {
        setError(prev => ({
          ...prev,
          [filter?.propertyField]: intl.formatMessage(messages.requiredField),
        }));
      } else {
        setError(prev => ({
          ...prev,
          [filter?.propertyField]: '',
        }));
      }
    }
  };

  return (
    <>
      <SelectInput
        id={filter?.propertyField || filter?.labelField}
        name={filter?.propertyField || filter?.labelField}
        label={
          filter?.mandatory
            ? `${filter?.labelField || filter?.propertyField} * `
            : filter?.labelField || filter?.propertyField
        }
        onChange={listValidator}
        options={formListOptions || []}
        value={selectedValue}
        required={filter?.mandatory}
      />
      {error && (
        <label color="danger" htmlFor="startDate-field" className="mt-0 text-danger lh-1 word-wrap">
          <small>{error}</small>
        </label>
      )}
    </>
  );
};

export default ListField;
